var version = {
    "name":      "dativery",
    "buildDateCode": "20260128-145553",
    "buildDate": "Wed Jan 28 2026 14:55:53 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260128-145553",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;